// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const MergeLogs = t.struct({
    mergeTime: t.String,
    modifyBy: t.String,
    mrgCmpEntityId: t.Number,
    mrgEntityId: t.Number,
    svrCmpEntityId: t.Number,
    svrEntityId: t.Number
}, {
    defaultProps: {
        mergeTime: '',
        modifyBy: '',
        mrgCmpEntityId: 0,
        mrgEntityId: 0,
        svrCmpEntityId: 0,
        svrEntityId: 0
    },
    name: 'MergeLogs',
    strict: true
});
